(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
  const data = window.SLDEstimatorData;
  const product = data.products.poleSack;
  const controls = data.productControls.poleSack;
  const sack = data.productControls.stakeSack;
  const closure = data.shared.components.sackClosure;
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const prompt = 'Select your fabric, width, and length to see the estimated weight.';

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const label=Object.keys(product.FIELD_LABELS).find(key=>key.replace(/\s+/g,' ').trim()===String(element.labels&&element.labels[0]&&element.labels[0].textContent||'').replace(/\s+/g,' ').trim());
      if (!own(product.FIELD_LABELS, label)) continue;
      const field = product.FIELD_LABELS[label];
      selected[field] = own(selected, field) ? null : element.value;
    }
    for (const field of Object.values(product.FIELD_LABELS)) {
      if (!own(selected, field)) selected[field] = null;
    }
    return selected;
  }

  function estimate(choice) {
    if (choice.Fabric === product.CUSTOM_FABRIC) return {manual:true,message:'Custom fabric requires a manual weight estimate. Please contact me before ordering.'};
    const bottom = choice.Bottom === undefined || choice.Bottom === '' ? 'No' : choice.Bottom;
    const daisy = choice.Daisy === undefined || choice.Daisy === '' ? 'No' : choice.Daisy;
    if (!own(product.FABRICS, choice.Fabric) || !own(product.WIDTHS, choice.Width) || !own(product.LENGTHS, choice.Length) || !own(product.BOTTOM, bottom) || !own(product.DAISY, daisy)) return null;
    const width = product.WIDTHS[choice.Width], length = product.LENGTHS[choice.Length];
    if (width < controls.minWidth || width > controls.maxWidth || length < controls.minLength || length > controls.maxLength) return null;
    const rawWidth = width * sack.rawWidthMultiplier + sack.rawWidthExtra;
    let allowance = sack.rawLengthExtra;
    if (product.DAISY[daisy]) {
      if (length >= controls.daisy.longStart) allowance = controls.daisy.longAllowance;
      else if (length >= controls.daisy.mediumStart) allowance = controls.daisy.mediumAllowance;
    }
    const rawLength = length + allowance;
    const body = rawWidth * rawLength / 1296 * product.FABRICS[choice.Fabric].planningDensity;
    const drawstring = (rawWidth + sack.drawstringExtra) * closure.catchAllDrawstringPerInch * sack.drawstringCount;
    const lock = closure.mediumCordLock * sack.cordLockCount;
    const webbingLength = product.DAISY[daisy] ? controls.webbing.baseLength + controls.webbing.step * Math.floor((length - controls.webbing.baseSackLength) / controls.webbing.step) : 0;
    const webbing = webbingLength * (width <= controls.smallWebbingMaxWidth ? controls.webbing.halfInchPerInch : controls.webbing.fiveEighthPerInch);
    const reinforcement = product.BOTTOM[bottom] ? (rawWidth - sack.reinforcement.lengthDeduction) * sack.reinforcement.weightPerInch : 0;
    const finished = body + drawstring + lock + webbing + reinforcement + sack.constructionAllowance;
    return {rawWidth, rawLength, body, drawstring, lock, webbingLength, webbing, reinforcement, finished, grams:finished * sack.gramsPerOunce};
  }

  function format(result) {
    return result.finished.toFixed(sack.displayOunceDecimals) + ' oz / ' + Math.round(result.grams) + ' g';
  }

  function start() {
    const root = document.querySelector('[data-sld-pole-sack-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;
    const results = root.querySelector('[data-sld-estimator-results]');
    const message = root.querySelector('[data-sld-estimator-message]');
    const weight = root.querySelector('[data-sld-weight-pole-sack]');
    function text(element, value) {
      if (element && element.textContent !== value) element.textContent = value;
    }
    function calculate() {
      const result = estimate(selections(scope));
      const valid = result && !result.manual;
      if (results) results.hidden = !valid;
      text(message, valid ? '' : result && result.manual ? result.message : prompt);
      text(weight, valid ? format(result) : '');
    }
    let timer;
    const queue = () => { clearTimeout(timer); timer = setTimeout(calculate, 75); };
    scope.addEventListener('change', queue, true);
    scope.addEventListener('input', queue, true);
    new MutationObserver(mutations => {
      if (mutations.some(mutation => !root.contains(mutation.target))) queue();
    }).observe(scope, {subtree:true, childList:true, attributes:true, attributeFilter:['value','checked','selected']});
    calculate();
  }
  return {estimate, selections, format, start};
});
